import { PlusOutlined } from "@ant-design/icons";
import { Button, Form, Row, Space, Spin, Table } from "antd";
import { useEffect, useRef, useState } from "react";

import courseApi from "../../../api/course";
import ListActionButton from "../../../components/ListActionButton/ActionListButton";
import ModalCustom from "../../../components/ModalCustom/ModalCustom";
import InputFields from "../../../components/InputFields/InputFields";
import Notification from "../../../components/Notification";
import {
  columnsTableOneCourse,
  dataOnceCourse,
  oneCourseSearch,
} from "../config";
import Search from "../../../components/Search/Search";

const OneCourse = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [params, setParams] = useState({
    pageNumber: 1,
    pageSize: 20,
  });
  const [total, setTotal] = useState();
  const addOnceCourse = useRef();
  const [formAddOnceCourse] = Form.useForm();
  const [textModalOnceCourse, setTextModalOnceCourse] = useState({
    text: "Thêm mới",
    status: 0,
  });
  const onChangePagination = (pageNumber, pageSize) => {
    setParams({ ...params, pageNumber: pageNumber, pageSize: pageSize });
  };

  const oneCourseSearchRef = useRef();

  const [idOnceCourse, setIdOnceCourse] = useState(null);

  const getListOnceCourse = async () => {
    try {
      const res = await courseApi.getListCourse(params);
      console.log("🚀 ~ getListOnceCourse ~ res:", res);
      const newDataSource = res.data.map((item) => ({
        ...item,
        key: item.id,
      }));
      setData(newDataSource);
      setTotal(res.total);
      Notification("success", "Lấy danh sách mẫu hợp đồng thành công");
    } catch (error) {
      Notification("error", "Lấy danh sách mẫu hợp đồng không thành công");
    }
  };

  const handleAddOneCourse = async () => {
    setTextModalOnceCourse({
      status: 0,
      text: "Thêm mới",
    });
    try {
      const data = await formAddOnceCourse.validateFields();
      await courseApi.addCourse(data);
      addOnceCourse.current.closeModal();
      Notification("success", "Tạo mới thành công");
      formAddOnceCourse.resetFields();
      getListOnceCourse();
    } catch (error) {
      Notification("error", "Tạo mới không thành công");
    }
  };

  const handleEditOneCourse = async () => {
    try {
      const data = await formAddOnceCourse.validateFields();
      await courseApi.updateCourse({
        ...data,
        id: idOnceCourse,
      });
      addOnceCourse.current.closeModal();
      getListOnceCourse();
      Notification("success", "Cập nhật thành công");
      formAddOnceCourse.resetFields();
      setIdOnceCourse(null);
    } catch (error) {
      Notification("error", "Cập nhật không thành công");
    }
  };

  const handleDeleteOneCourse = async (id) => {
    try {
      await courseApi.deleteCourse(id);
      Notification("success", "Xoá thành công");
      formAddOnceCourse.resetFields();
      setIdOnceCourse(null);
      getListOnceCourse();
    } catch (error) {
      Notification("error", "Xoá không thành công");
    }
  };

  const handleSearch = () => {
    const data = oneCourseSearchRef.current.getData();
    setParams({
      ...params,
      ...data,
      page: 1,
    });
  };

  const columns = columnsTableOneCourse.map((e) => {
    if (e.key === "stt") {
      return {
        ...e,
        render: (text, record, index) =>
          (params.pageNumber - 1) * params.pageSize + index + 1,
      };
    } else if (e.key == "action") {
      e.render = (_, record, index) => {
        return (
          <ListActionButton
            deleteFunction={() => {
              handleDeleteOneCourse(record.id);
            }}
            editFunction={() => {
              formAddOnceCourse.setFieldsValue(record);
              addOnceCourse.current.openModal();
              setIdOnceCourse(record.id);
              setTextModalOnceCourse({
                status: 1,
                text: "Chỉnh sửa",
              });
            }}
          />
        );
      };
    }
    return e;
  });

  //
  useEffect(() => {
    getListOnceCourse();
  }, [params]);

  return (
    <Spin spinning={loading}>
      <div className="container">
        <div
          onKeyDown={(e) => {
            if (e.keyCode === 13) {
              handleSearch();
            }
          }}
        >
          <Search
            fields={oneCourseSearch}
            onClickSearch={handleSearch}
            ref={oneCourseSearchRef}
          />
        </div>
      </div>
      <div className="container">
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          <Row justify="space-between">
            <div className="title">Danh sách khóa lẻ</div>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => {
                addOnceCourse.current.openModal();
                formAddOnceCourse.resetFields();
              }}
            >
              Tạo mới
            </Button>
          </Row>
          <Table
            columns={columns}
            dataSource={data}
            pagination={{
              position: ["bottomRight"],
              showSizeChanger: true,
              total: total,
              pageSize: params.pageSize,
              current: params.page,
              onChange: onChangePagination,
            }}
            bordered
          />
          <ModalCustom
            ref={addOnceCourse}
            title={`${textModalOnceCourse.text}`.toLocaleUpperCase()}
          >
            <Space
              direction="vertical"
              size={"large"}
              style={{
                width: "100%",
              }}
            >
              <Form form={formAddOnceCourse}>
                <Row gutter={[16, 8]}>
                  <InputFields data={dataOnceCourse} />
                </Row>
              </Form>
              <Row justify={"end"}>
                <Space đirection="horizontal" size="small">
                  <Button
                    type="primary"
                    onClick={
                      textModalOnceCourse.status === 0
                        ? handleAddOneCourse
                        : handleEditOneCourse
                    }
                  >
                    {`${textModalOnceCourse.text}`}
                  </Button>
                  <Button
                    danger
                    onClick={() => addOnceCourse.current.closeModal()}
                  >
                    Hủy
                  </Button>
                </Space>
              </Row>
            </Space>
          </ModalCustom>
        </Space>
      </div>
    </Spin>
  );
};
export default OneCourse;
